import React, { useEffect, useState, useRef } from 'react';
import RadarActionManager, { ActionType } from '../../utils/radarActionManager';
import { ScrollActionController } from './ScrollActionController';
import { VisualDisplay } from './VisualDisplay';
import './Article.css';
import './ArticleDisplay.css';

interface ArticleProps {
    content: React.ReactNode;
    radarWidth?: number;
    radarHeight?: number;
    className?: string;
}

/**
 * Composant principal d'article avec radar intégré
 * Il utilise à la fois ScrollActionController et RadarDisplay
 */
export const Article: React.FC<ArticleProps> = ({
    content,
    radarWidth = 900,
    radarHeight = 800,
    className = ''
}) => {
    // Référence vers le gestionnaire d'actions
    const actionManager = useRef(RadarActionManager.getInstance());
    const [processedContent, setProcessedContent] = useState<React.ReactNode>(content);
    const [isCanvasVisible, setIsCanvasVisible] = useState(false);

    // Préparer le contenu en traitant les balises d'action anciennes et nouvelles
    useEffect(() => {
        if (typeof content === 'object' && React.isValidElement(content)) {
            const element = content as React.ReactElement;

            // Si le contenu est un élément React avec dangerouslySetInnerHTML
            if (element.props && element.props.dangerouslySetInnerHTML) {
                const html = element.props.dangerouslySetInnerHTML.__html;

                if (typeof html === 'string') {
                    // Traiter les anciennes balises #[...]# en nouvelles balises [action]
                    const processedHtml = RadarActionManager.prepareContentWithLegacyActions(html);

                    // Créer un nouvel élément avec le HTML transformé
                    const newElement = React.cloneElement(element, {
                        dangerouslySetInnerHTML: { __html: processedHtml }
                    });

                    setProcessedContent(newElement);
                }
            }
        } else {
            // Si c'est un autre type de contenu, le laisser tel quel
            setProcessedContent(content);
        }
    }, [content]);

    // Réinitialiser le gestionnaire d'actions au chargement du composant
    useEffect(() => {
        actionManager.current.resetState();

        return () => {
            // Nettoyage optionnel lors du démontage
        };
    }, []);

    return (
        <div className={`article-container ${className}`}>
            <div className="article-content">
                <ScrollActionController isVisible={isCanvasVisible} setIsCanvasVisible={setIsCanvasVisible}>
                    {processedContent}


                </ScrollActionController>
                <div style={{ height: "400px" }}>

                </div>
            </div >

            <VisualDisplay
                width={radarWidth}
                height={radarHeight}
                isVisible={isCanvasVisible}
                className="radar-main-display"
            />
        </div >
    );
}; 